import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function PublicNav() {
    const { user } = useAuth();
    const nav = useNavigate();
    return (
        <header className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
            <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
                <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
                    <div className="w-7 h-7 bg-white text-black flex items-center justify-center font-display font-black text-sm">R</div>
                    <span className="font-display font-bold tracking-tight text-lg">RepurposeAI</span>
                </Link>
                <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
                    <Link to="/" data-testid="nav-home" className="hover:text-white transition-colors">Home</Link>
                    <Link to="/pricing" data-testid="nav-pricing" className="hover:text-white transition-colors">Pricing</Link>
                </nav>
                <div className="flex items-center gap-3">
                    {user ? (
                        <Button
                            data-testid="nav-app-btn"
                            onClick={() => nav("/app/dashboard")}
                            className="bg-white text-black hover:bg-zinc-200 font-medium"
                        >
                            Open app →
                        </Button>
                    ) : (
                        <>
                            <Link to="/login" data-testid="nav-login" className="text-sm text-zinc-400 hover:text-white">Login</Link>
                            <Button
                                data-testid="nav-signup-btn"
                                onClick={() => nav("/register")}
                                className="bg-white text-black hover:bg-zinc-200 font-medium"
                            >
                                Get started →
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
